import React from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
import { useStoreState } from "easy-peasy";
import IndicadoresTecnicos from "./IndicadoresTecnicos";
import GestaoSenai from "./GestaoSenai";
import IndicadoresFinanceiros from "./IndicadoresFinanceiros";
import Relatorio from "./Retatorio";
import Estagios from "./Estagios";
import PainelMonitoramento from "./PainelMonitoramento";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`impl-tabpanel-${index}`}
      aria-labelledby={`impl-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const Indicadores = () => {
  let user = useStoreState((state) => state.auth.user);
  const allowedMonitoramentoEmails = ["wendell.pacheco@giz.de", "marcos.medeiros@pumpkintech.com.br"];
  const showMonitoramento = allowedMonitoramentoEmails.includes(user?.email?.toLowerCase());

  const [abaImpl, setAbaImpl] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setAbaImpl(newValue);
  };

  function a11yProps(index) {
    return {
      id: `impl-tab-${index}`,
      "aria-controls": `impl-tabpanel-${index}`,
    };
  }

  return (
    <Paper variant="outlined" className="center-box" sx={{ my: 3 }}>
      <Tabs
        value={abaImpl}
        onChange={handleTabChange}
        centered
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Indicadores Tecnicos" {...a11yProps(0)} />
        <Tab label="Indicadores Financeiros" {...a11yProps(1)} />
        <Tab label="Dashboard SENAI" {...a11yProps(2)} />
        <Tab label="Relatorio" {...a11yProps(3)} />
        <Tab label="Estágios" {...a11yProps(4)} />
        {showMonitoramento && <Tab label="Monitoramento" {...a11yProps(5)} />}
      </Tabs>

      {/* Indicadores Tecnicos */}
      <TabPanel value={abaImpl} index={0} className="tabpanel">
        <IndicadoresTecnicos />
      </TabPanel>

      {/* Indicadores Financeiros */}
      <TabPanel value={abaImpl} index={1} className="tabpanel">
        <IndicadoresFinanceiros />
      </TabPanel>

      {/* Dashboard SENAI */}
      <TabPanel value={abaImpl} index={2} className="tabpanel">
        <GestaoSenai />
      </TabPanel>

      {/* Relatorio */}
      <TabPanel value={abaImpl} index={3} className="tabpanel">
        <Relatorio />
      </TabPanel>

      {/* Estágios */}
      <TabPanel value={abaImpl} index={4} className="tabpanel">
        <Estagios />
      </TabPanel>

      {/* Monitoramento */}
      {showMonitoramento && (
        <TabPanel value={abaImpl} index={5} className="tabpanel">
          <PainelMonitoramento />
        </TabPanel>
      )}
    </Paper>
  );
};

export default Indicadores;
